import React, { useEffect } from "react";
import { authHelper } from "../../utils/helpers";
import { fetchLogoutProxy } from "../../utils/helpers/api";
import { useGlobalState } from "../../contexts/GlobalContext";
import { Routes } from "../../utils/constants";
import { useNavigate } from "react-router-dom";

const Logout: React.FC = () => {
  const navigate = useNavigate();
  
  const { setStateValue } = useGlobalState();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const returnTo = urlParams.get("returnto") ?? "";

    if (authHelper.isAuth()) {
      handleLogout(returnTo);
    } else {
      handleRedirect(returnTo);
    }
    document.title = "宣伝会議 : アカウント管理";
  }, []);

  const handleRedirect = (returnTo: string) => {
    if(returnTo) {
      window.location.href = returnTo;
    } else {
      navigate(Routes.USERGUEST);
    }
  }

  const handleLogout = async (returnTo: string) => {
    setStateValue("loader", true);
    try {
      await fetchLogoutProxy();
    } catch (error) {
      return error;
    } finally {
      authHelper.logOut();
      handleRedirect(returnTo);
      setStateValue("loader", false);
    }
  };
  return <></>;
};

export default Logout;
